import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Search, Upload, User, LogOut, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

function Navbar({ onMenuClick }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="icon-btn" onClick={onMenuClick}>
          <Menu size={24} />
        </button>
        <div className="logo" onClick={() => navigate('/')}>
          <svg viewBox="0 0 40 40" className="logo-icon" fill="none">
            <defs>
              <linearGradient id="filmGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{stopColor: '#ff6b6b', stopOpacity: 1}} />
                <stop offset="100%" style={{stopColor: '#4ecdc4', stopOpacity: 1}} />
              </linearGradient>
            </defs>
            <rect x="4" y="8" width="32" height="24" rx="2" stroke="url(#filmGradient)" strokeWidth="2.5" fill="none"/>
            <rect x="4" y="12" width="32" height="2" fill="url(#filmGradient)"/>
            <rect x="4" y="26" width="32" height="2" fill="url(#filmGradient)"/>
            <circle cx="8" cy="10" r="1.5" fill="url(#filmGradient)"/>
            <circle cx="32" cy="10" r="1.5" fill="url(#filmGradient)"/>
            <circle cx="8" cy="30" r="1.5" fill="url(#filmGradient)"/>
            <circle cx="32" cy="30" r="1.5" fill="url(#filmGradient)"/>
            <path d="M16 16 L26 20 L16 24 Z" fill="url(#filmGradient)"/>
          </svg>
          <span className="logo-text">dmshortfilms</span>
        </div>
      </div>

      <div className="navbar-center">
        <form className="search-form" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit" className="search-btn">
            <Search size={20} />
          </button>
        </form>
      </div>

      <div className="navbar-right">
        {isAuthenticated && (
          <button className="icon-btn" onClick={() => navigate('/upload')} title="Upload Video">
            <Upload size={24} />
          </button>
        )}
        
        {isAuthenticated ? (
          <div className="user-menu-container">
            <button 
              className="user-avatar-btn" 
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <img src={user.avatar} alt={user.username} className="user-avatar" />
            </button>
            
            {showUserMenu && (
              <div className="user-menu">
                <div className="user-menu-header">
                  <img src={user.avatar} alt={user.username} className="user-menu-avatar" />
                  <div>
                    <div className="user-menu-name">{user.username}</div>
                    <div className="user-menu-email">{user.email}</div>
                  </div>
                </div>
                <div className="user-menu-divider"></div>
                <button className="user-menu-item" onClick={() => {
                  setShowUserMenu(false);
                  navigate('/my-channel');
                }}>
                  <User size={18} />
                  <span>My Channel</span>
                </button>
                <button className="user-menu-item" onClick={() => {
                  setShowUserMenu(false);
                  navigate('/create-channel');
                }}>
                  <User size={18} />
                  <span>Create Channel</span>
                </button>
                <button className="user-menu-item" onClick={() => {
                  setShowUserMenu(false);
                  logout();
                  navigate('/');
                }}>
                  <LogOut size={18} />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        ) : (
          <button className="btn btn-primary" onClick={() => navigate('/login')}>
            <LogIn size={18} />
            <span>Login</span>
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
